import React, { ReactNode } from "react";
import { useHistory } from "react-router-dom";
import { Button, Card, CardActions, CardContent } from "@material-ui/core";

const AdvisoryItem = ({ advisory }): ReactNode => {
  const navigate = useHistory();

  const onCTAClick = (): void => {
    navigate.push(`/advisories/${advisory.nid}`);
  };

  return (
    <Card className="advisory-card">
      <CardContent style={{ flex: 0.5 }}>
        <p
          className="font-bold primary-font-color"
          dangerouslySetInnerHTML={{ __html: advisory.title }}
        />
        <br />
        <div
          className="line-clamp-4"
          dangerouslySetInnerHTML={{ __html: advisory.content }}
        />
      </CardContent>
      <CardActions
        style={{ flex: 0.5, alignItems: "flex-end", padding: "20px 13px" }}
      >
        {advisory.cta !== "" && (
          <Button
            fullWidth
            onClick={onCTAClick}
            size="medium"
            variant="contained"
            color="secondary"
          >
            {advisory.cta}
          </Button>
        )}
      </CardActions>
    </Card>
  );
};

export default AdvisoryItem;
